import React from 'react';

import { Loader, Stack, Text, useMantineTheme } from '@mantine/core';
import { DropzoneProps, FileRejection, FileWithPath } from '@mantine/dropzone';
import { IconPhoto } from '@tabler/icons-react';

import FileUpload from './FileUpload';

interface IImageUploadProps {
  handleFileChange: (arg: FileWithPath[]) => void;
  width?: number | string;
  height?: number | string;
  size?: number;
  imgSrc: string;
  handleFileReject?: (files: FileRejection[]) => void;
  disabled?: boolean;
  children?: DropzoneProps['children'];
  loading?: boolean;
}

const ImageUpload = ({
  handleFileChange,
  imgSrc,
  handleFileReject,
  disabled,
  width = 100,
  height = 100,
  size = 100,
  loading = false,
}: IImageUploadProps): JSX.Element => {
  const theme = useMantineTheme();
  return (
    <FileUpload
      size={size}
      onDrop={handleFileChange}
      disabled={disabled}
      handleFileReject={handleFileReject}
      sx={{
        border: '1px solid',
        '&:hover': {
          backgroundColor: !disabled ? theme.colors.gray[1] : 'white',
          borderColor: !disabled ? theme.colors.kiloBlue : undefined,
          cursor: !disabled ? 'pointer' : 'default',
        },
      }}
    >
      {imgSrc ? (
        <img src={imgSrc} style={{ width: width, height: height }} />
      ) : (
        <Stack align='center'>
          <Text size='lg'>Add Image</Text>
          <Text size='sm' color='dimmed'>
            Drag and drop or click here
          </Text>
          <IconPhoto size={size} />
          {loading && <Loader />}
        </Stack>
      )}
    </FileUpload>
  );
};

export default ImageUpload;
